<template>
  <v-card>
    <div v-for="(item, i) in insureds" :key="i">
      <v-card-title>
        <div class="headline">Insured Person {{item.seqNo}} Details</div>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.name}}</v-subheader>
            <div class="title">{{item.name}}</div>
          </v-flex>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.nricPassport}}</v-subheader>
            <div class="title">{{item.nricPassport}}</div>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.dob}}</v-subheader>
            <div class="title">{{item.dob}}</div>
          </v-flex>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.gender}}</v-subheader>
            <div class="title">{{formatGender(item.gender)}}</div>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.isStudent}}</v-subheader>
            <div class="title">{{formatBoolean(item.isStudent)}}</div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
    </div>
  </v-card>
</template>

<script>
import { globalMixin } from './globalMixin'

export default {
  data() {
    return {
      labels: {
        name: 'Name as in NRIC/Passport',
        nricPassport: 'NRIC/Passport No.',
        dob: 'Date of Birth',
        gender: 'Gender',
        isStudent: 'Are you a full time student?'
      }
    }
  },
  methods: {

  },
  computed: {
    insureds() {
      return this.$store.state.adminMember.member.trans.insuredInfo.insureds
    }
  },
  mixins: [globalMixin]
}
</script>

<style>
</style>
